import { SignUpHeader } from '../components/SignUpHeader';
import { SignUpForm } from '../components/SignUpForm';
import { AuthTabs } from '../components/AuthTabs';
import { RedirectIfAuthed } from '../../lib/use-auth';

export default function SignUpPage() {
  return (
    <RedirectIfAuthed>
      <div className="size-full bg-white flex flex-col">
        <div className="pt-0">
          <SignUpHeader showSwitchButton={false} />
        </div>
        <div className="flex-1 flex flex-col items-center justify-center py-12 px-4">
          <AuthTabs mode="signup" active="customer" />
          <SignUpForm />
        </div>
      </div>
    </RedirectIfAuthed>
  );
}
